import questionTypes from '../questionTypes';
import formatValidationTypeList from '../formatValidationTypeList';
import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.respondentBlankField,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    label: 'Blank label',
    formatValidationType: formatValidationTypeList.none,
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isUniqueField: () => false,
    isRequiredField: () => false,
    isTextRequired: () => false,
  },
};
